import type { WorkflowCompletion } from '@interfaces/workflow';
import { createContext } from 'react';

export type ActionContextInterface = {
  activeWorkflows: WorkflowCompletion[];
  activeUserId?: string;
  unsignedDocuments: boolean;
  refetch: () => void;
  refreshWidgets?: () => void;
  widgetRefreshSignal?: number;
};

export const ActionContext = createContext<ActionContextInterface>({
  activeWorkflows: [],
  unsignedDocuments: false,
  refetch: () => {},
  refreshWidgets: () => {},
  widgetRefreshSignal: 0,
});
